<template>
  <div id="sms-error-container">
    <MarkdownCopy :content="$t.genericErrorMessageText" />
  </div>
</template>

<script setup>
import '@garmin/components-global-web/dist-web/components/GCopy';
import MarkdownCopy from './MarkdownCopy.vue';

defineOptions({
  name: 'SmsError',
});
</script>
